import { render, staticRenderFns } from "./SourceSelectorButton.vue?vue&type=template&id=488e6460&"
import script from "./SourceSelectorButton.vue?vue&type=script&lang=js&"
export * from "./SourceSelectorButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports